import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const sizeMap = { small: "sm", medium: "default", large: "lg" };

const GreenButton = React.forwardRef(
  ({ size = "medium", fullWidth = false, className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="success"
      size={sizeMap[size] || "default"}
      className={cn(fullWidth && "w-full", className)}
      {...props}
    />
  ),
);
GreenButton.displayName = "GreenButton";

export default GreenButton;
